import axiosInstance from "@/axios/axiosInstance";
import { IApiError } from "@/interface/apiError.types";
import { parseApiError } from "@/lib/error-parser";
import { TranslationData } from "@/interface/translation.types";
import { API_CONFIG } from "@/config";

export const fetchTranslations = async (): Promise<TranslationData> => {
  try {
    const res = await axiosInstance.get("/languages/sync-translation/cms", {
      headers: {
        "api-key": API_CONFIG.cmsApiKey,
      },
    });

    return res?.data?.data;
  } catch (error) {
    await parseApiError(error as IApiError);
    throw error;
  }
};

export const uploadExcel = async (
  file: File,
  isFrontendTranslation: boolean = false
) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axiosInstance.post(
      `/languages/upload-translation/${
        isFrontendTranslation ? "backend" : "cms"
      }`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    parseApiError(error as IApiError);
    return null;
  }
};

export const exportTranslation = async (
  isFrontendTranslation: boolean = false
): Promise<Blob> => {
  try {
    const response = await axiosInstance.get<Blob>(
      `/languages/download-translation/${
        isFrontendTranslation ? "backend" : "cms"
      }`,
      {
        responseType: "blob",
      }
    );

    return response.data;
  } catch (error) {
    await parseApiError(error as IApiError);
    throw error;
  }
};
